/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  StatusUpdatedActionPayload,
  Step1ButtonClickActionPayload,
  OtherSurnameUpdatedActionPayload,
  SurnameUpdatedActionPayload,
  OtherNameUpdatedActionPayload,
  NameUpdatedActionPayload,
  KvkkVisibilityUpdatedActionPayload,
  OtherTcIdUpdatedActionPayload,
  OtherPassaportNoActionPayload,
  OtherPassaportExpirationDateUpdatedActionPayload,
  OtherDateOfBirthActionPayload,
  OtherGenderUpdatedActionPayload,
  UpdateUserClientActionPayload,
  FormSubmitStep2ActionPayload,
  MedicationsUpdatedActionPayload,
  AllergiesUpdatedActionPayload,
  LoyaltProgramNumberUpdatedActionPayload,
  PassaportExpirationDateActionPayload,
  PassaportNoUpdatedActionPayload,
  TcIdUpdatedActionPayload,
  DateOfBirthUpdatedActionPayload,
  GenderUpdatedActionPayload,
  ClientFormDataActionPayload,
  IsTurkeyCitizenUpdatedActionPayload,
  GetClientsSuccessfulActionPayload,
  GetClientByIdActionPayload,
  GetClientByIdSuccessfulActionPayload,
  GetActiveClientWithRelationsByIdActionPayload,
  GetActiveClientByIdWithRelationsSuccessfulActionPayload,
  CreateClientActionPayload,
  CreateClientSuccessfulActionPayload,
  UpdateClientActionPayload,
  UpdateClientSuccessfulActionPayload,
  DeleteClientActionPayload,
  DeleteClientSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/client-data-store';

/* action types */
export enum ActionTypes {
  UpdateClientTourStatus = '[CLIENT] UpdateClientTourStatus',
  UpdateClientTourStatusSuccessful = '[CLIENT] UpdateClientTourStatusSuccessful',
  StatusUpdated = '[CLIENT] StatusUpdated',
  Step1ButtonClick = '[CLIENT] Step1ButtonClick',
  OtherSurnameUpdated = '[CLIENT] OtherSurnameUpdated',
  SurnameUpdated = '[CLIENT] SurnameUpdated',
  OtherNameUpdated = '[CLIENT] OtherNameUpdated',
  NameUpdated = '[CLIENT] NameUpdated',
  FormSubmitStep4 = '[CLIENT] FormSubmitStep4',
  KvkkVisibilityUpdated = '[CLIENT] KvkkVisibilityUpdated',
  OtherTcIdUpdated = '[CLIENT] OtherTcIdUpdated',
  OtherPassportNoUpdated = '[CLIENT] OtherPassportNoUpdated',
  OtherPassportExpirationDateUpdated = '[CLIENT] OtherPassportExpirationDateUpdated',
  OtherDateOfBirthUpdated = '[CLIENT] OtherDateOfBirthUpdated',
  OtherGenderUpdated = '[CLIENT] OtherGenderUpdated',
  UpdateUserClientFailure = '[CLIENT] UpdateUserClientFailure',
  UpdateUserClientSuccessful = '[CLIENT] UpdateUserClientSuccessful',
  UpdateUserClient = '[CLIENT] UpdateUserClient',
  BackStep1 = '[CLIENT] BackStep1',
  FormSubmitStep3 = '[CLIENT] FormSubmitStep3',
  FormSubmitStep2 = '[CLIENT] FormSubmitStep2',
  MedicationsUpdated = '[CLIENT] MedicationsUpdated',
  AllergiesUpdated = '[CLIENT] AllergiesUpdated',
  LoyaltProgramNumberUpdated = '[CLIENT] LoyaltProgramNumberUpdated',
  PassportExpirationDateUpdated = '[CLIENT] PassportExpirationDateUpdated',
  PassportNoUpdated = '[CLIENT] PassportNoUpdated',
  DateOfBirthUpdated = '[CLIENT] DateOfBirthUpdated',
  GenderUpdated = '[CLIENT] GenderUpdated',
  ClientFormData = '[CLIENT] ClientFormData',
  FormStep1Submit = '[CLIENT] FormStep1Submit',
  IsTurkeyCitizenUpdated = '[CLIENT] IsTurkeyCitizenUpdated',
  InitFetchingActiveClientWithRelations = '[CLIENT] InitFetchingActiveClientWithRelations',
  GetClients = '[CLIENT] GetClients',
  GetClientsSuccessful = '[CLIENT] GetClientsSuccessful',
  GetClientsFailure = '[CLIENT] GetClientsFailure',
  GetClientById = '[CLIENT] GetClientById',
  GetClientByIdSuccessful = '[CLIENT] GetClientByIdSuccessful',
  GetClientByIdFailure = '[CLIENT] GetClientByIdFailure',
  GetActiveClientWithRelationsById = '[CLIENT] GetActiveClientWithRelationsById',
  GetActiveClientByIdWithRelationsSuccessful = '[CLIENT] GetActiveClientByIdWithRelationsSuccessful',
  GetActiveClientByIdWithRelationsFailure = '[CLIENT] GetActiveClientByIdWithRelationsFailure',
  CreateClient = '[CLIENT] CreateClient',
  CreateClientSuccessful = '[CLIENT] CreateClientSuccessful',
  CreateClientFailure = '[CLIENT] CreateClientFailure',
  UpdateClient = '[CLIENT] UpdateClient',
  UpdateClientSuccessful = '[CLIENT] UpdateClientSuccessful',
  UpdateClientFailure = '[CLIENT] UpdateClientFailure',
  DeleteClient = '[CLIENT] DeleteClient',
  DeleteClientSuccessful = '[CLIENT] DeleteClientSuccessful',
  DeleteClientFailure = '[CLIENT] DeleteClientFailure',
  ResetState = '[CLIENT] ResetState',
}

/* actions */

export const UpdateClientTourStatus = createAction(
  ActionTypes.UpdateClientTourStatus,
  props<{ payload: { id: string, status: string} }>(),
);

export const UpdateClientTourStatusSuccessful = createAction(
  ActionTypes.UpdateClientTourStatusSuccessful,
  props<{ payload: { id: string, status: string} }>(),
);

export const StatusUpdated = createAction(
  ActionTypes.StatusUpdated,
  props<{ payload: StatusUpdatedActionPayload }>(),
);

export const Step1ButtonClick = createAction(
  ActionTypes.Step1ButtonClick,
  props<{ payload: Step1ButtonClickActionPayload }>(),
);

export const OtherSurnameUpdated = createAction(
  ActionTypes.OtherSurnameUpdated,
  props<{ payload: OtherSurnameUpdatedActionPayload }>(),
);

export const SurnameUpdated = createAction(
  ActionTypes.SurnameUpdated,
  props<{ payload: SurnameUpdatedActionPayload }>(),
);

export const OtherNameUpdated = createAction(
  ActionTypes.OtherNameUpdated,
  props<{ payload: OtherNameUpdatedActionPayload }>(),
);

export const NameUpdated = createAction(
  ActionTypes.NameUpdated,
  props<{ payload: NameUpdatedActionPayload }>(),
);

export const FormSubmitStep4 = createAction(ActionTypes.FormSubmitStep4);

export const KvkkVisibilityUpdated = createAction(
  ActionTypes.KvkkVisibilityUpdated,
  props<{ payload: KvkkVisibilityUpdatedActionPayload }>(),
);

export const OtherTcIdUpdated = createAction(
  ActionTypes.OtherTcIdUpdated,
  props<{ payload: OtherTcIdUpdatedActionPayload }>(),
);

export const OtherPassportNoUpdated = createAction(
  ActionTypes.OtherPassportNoUpdated,
  props<{ payload: OtherPassaportNoActionPayload }>(),
);

export const OtherPassportExpirationDateUpdated = createAction(
  ActionTypes.OtherPassportExpirationDateUpdated,
  props<{ payload: OtherPassaportExpirationDateUpdatedActionPayload }>(),
);

export const OtherDateOfBirthUpdated = createAction(
  ActionTypes.OtherDateOfBirthUpdated,
  props<{ payload: OtherDateOfBirthActionPayload }>(),
);

export const OtherGenderUpdated = createAction(
  ActionTypes.OtherGenderUpdated,
  props<{ payload: OtherGenderUpdatedActionPayload }>(),
);

export const UpdateUserClientFailure = createAction(
  ActionTypes.UpdateUserClientFailure,
);

export const UpdateUserClientSuccessful = createAction(
  ActionTypes.UpdateUserClientSuccessful,
);

export const UpdateUserClient = createAction(
  ActionTypes.UpdateUserClient,
  props<{ payload: UpdateUserClientActionPayload }>(),
);

export const BackStep1 = createAction(ActionTypes.BackStep1);

export const FormSubmitStep3 = createAction(ActionTypes.FormSubmitStep3);

export const FormSubmitStep2 = createAction(
  ActionTypes.FormSubmitStep2,
  props<{ payload: FormSubmitStep2ActionPayload }>(),
);

export const MedicationsUpdated = createAction(
  ActionTypes.MedicationsUpdated,
  props<{ payload: MedicationsUpdatedActionPayload }>(),
);

export const AllergiesUpdated = createAction(
  ActionTypes.AllergiesUpdated,
  props<{ payload: AllergiesUpdatedActionPayload }>(),
);

export const LoyaltProgramNumberUpdated = createAction(
  ActionTypes.LoyaltProgramNumberUpdated,
  props<{ payload: LoyaltProgramNumberUpdatedActionPayload }>(),
);

export const PassportExpirationDateUpdated = createAction(
  ActionTypes.PassportExpirationDateUpdated,
  props<{ payload: PassaportExpirationDateActionPayload }>(),
);

export const PassportNoUpdated = createAction(
  ActionTypes.PassportNoUpdated,
  props<{ payload: PassaportNoUpdatedActionPayload }>(),
);

export const DateOfBirthUpdated = createAction(
  ActionTypes.DateOfBirthUpdated,
  props<{ payload: DateOfBirthUpdatedActionPayload }>(),
);

export const GenderUpdated = createAction(
  ActionTypes.GenderUpdated,
  props<{ payload: GenderUpdatedActionPayload }>(),
);

export const ClientFormData = createAction(
  ActionTypes.ClientFormData,
  props<{ payload: ClientFormDataActionPayload }>(),
);

export const FormStep1Submit = createAction(ActionTypes.FormStep1Submit);

export const IsTurkeyCitizenUpdated = createAction(
  ActionTypes.IsTurkeyCitizenUpdated,
  props<{ payload: IsTurkeyCitizenUpdatedActionPayload }>(),
);

export const InitFetchingActiveClientWithRelations = createAction(
  ActionTypes.InitFetchingActiveClientWithRelations,
);

/* This event gets the all Clients. */
export const GetClients = createAction(ActionTypes.GetClients);

/* This event is fired after getting all the Clients successfully. */
export const GetClientsSuccessful = createAction(
  ActionTypes.GetClientsSuccessful,
  props<{ payload: GetClientsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Clients. */
export const GetClientsFailure = createAction(ActionTypes.GetClientsFailure);

/* This event gets the Client by Client id. */
export const GetClientById = createAction(
  ActionTypes.GetClientById,
  props<{ payload: GetClientByIdActionPayload }>(),
);

/* This event is fired after getting Client by Client id successfully. */
export const GetClientByIdSuccessful = createAction(
  ActionTypes.GetClientByIdSuccessful,
  props<{ payload: GetClientByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Client by Client id. */
export const GetClientByIdFailure = createAction(
  ActionTypes.GetClientByIdFailure,
);

/* This event gets the active Client by Client id. */
export const GetActiveClientWithRelationsById = createAction(
  ActionTypes.GetActiveClientWithRelationsById,
  props<{ payload: GetActiveClientWithRelationsByIdActionPayload }>(),
);

/* This event is fired after getting Client by Client id successfully. */
export const GetActiveClientByIdWithRelationsSuccessful = createAction(
  ActionTypes.GetActiveClientByIdWithRelationsSuccessful,
  props<{ payload: GetActiveClientByIdWithRelationsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Client by Client id. */
export const GetActiveClientByIdWithRelationsFailure = createAction(
  ActionTypes.GetActiveClientByIdWithRelationsFailure,
);

/* This event creates a Client. */
export const CreateClient = createAction(
  ActionTypes.CreateClient,
  props<{ payload: CreateClientActionPayload }>(),
);

/* This event is fired after creating a Client successfully. */
export const CreateClientSuccessful = createAction(
  ActionTypes.CreateClientSuccessful,
  props<{ payload: CreateClientSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Client successfully. */
export const CreateClientFailure = createAction(
  ActionTypes.CreateClientFailure,
);

/* This event updates a Client. */
export const UpdateClient = createAction(
  ActionTypes.UpdateClient,
  props<{ payload: UpdateClientActionPayload }>(),
);

/* This event is fired after updating a Client successfully. */
export const UpdateClientSuccessful = createAction(
  ActionTypes.UpdateClientSuccessful,
  props<{ payload: UpdateClientSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Client successfully. */
export const UpdateClientFailure = createAction(
  ActionTypes.UpdateClientFailure,
);

/* This event deletes a Client. */
export const DeleteClient = createAction(
  ActionTypes.DeleteClient,
  props<{ payload: DeleteClientActionPayload }>(),
);

/* This event is fired after deleting a Client successfully. */
export const DeleteClientSuccessful = createAction(
  ActionTypes.DeleteClientSuccessful,
  props<{ payload: DeleteClientSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Client successfully. */
export const DeleteClientFailure = createAction(
  ActionTypes.DeleteClientFailure,
);

/* This event resets the Client state. */
export const ResetState = createAction(ActionTypes.ResetState);
